module.exports = __webpack_public_path__ + "static/media/promo_mobile.fe7d7669.png";